import { Injectable } from '@angular/core';
import { MeterQuery, MeterRow } from '@contracts';
import { BehaviorSubject, finalize, map, Observable, tap } from 'rxjs';
import { mapMeterRows } from '../data-access/meter.mapper';
import { MeterService } from '../data-access/meter.service';

@Injectable()
export class MeterFacade {
  private readonly _rows = new BehaviorSubject<MeterRow[]>([]);
  private readonly _loading = new BehaviorSubject<boolean>(false);

  readonly rows$ = this._rows.asObservable();
  readonly loading$ = this._loading.asObservable();

  constructor(private readonly meterService: MeterService) {}

  load(query: MeterQuery): Observable<MeterRow[]> {
    this._loading.next(true);

    return this.meterService.getMeters(query).pipe(
      map((res) => mapMeterRows(res.meta.response_data ?? [])),
      tap((rows) => this._rows.next(rows)),
      finalize(() => this._loading.next(false)),
    );
  }
}
